import { displayAtom } from "@/atoms/display";
import { useAtomValue } from "jotai/index";

export const useDisplay = () => {
  return useAtomValue(displayAtom);
};
